import { render, staticRenderFns } from "./suitch-battery-widget.vue?vue&type=template&id=55ec2ef0&scoped=true&"
import script from "./suitch-battery-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-battery-widget.vue?vue&type=script&lang=js&"
import style0 from "./suitch-battery-widget.vue?vue&type=style&index=0&id=55ec2ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ec2ef0",
  null
  
)

export default component.exports